<template>
  <div id="app" class="dashboard">
    <!-- 头部 -->
    <div class="header">
      <h1>新太阳一号数据看板</h1>
      <div class="header-info">
        <span>更新时间: {{ currentTime }}</span>
        <span>系统状态: 正常运行</span>
      </div>
    </div>
    <!-- 顶部区域 -->
    <div class="top-section">
      <!-- 平台总余额 -->
      <div class="balance-card">
        <div class="balance-title">平台总余额</div>
        <div class="balance-amount" :class="{ pulse: platformBalance.isUpdating }">
          {{ formatCurrency(platformBalance.amount) }}
        </div>
        <div class="balance-unit">USDT</div>
        <div class="balance-change">
          {{ platformBalance.usdt }}u
        </div>
      </div>

      <!-- 概览统计 -->
      <div class="overview-stats">
        <div class="overview-title">
          📊 核心指标概览
          <button class="refresh-btn" @click="getMessage" :disabled="isRefreshing">
            {{ isRefreshing ? '刷新中...' : '刷新' }}
          </button>
        </div>
        <div class="overview-grid">
          <div class="overview-item" v-for="item in overviewStats" :key="item.key">
            <div class="overview-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="overview-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <!-- 充值相关 -->
      <div class="section-card">
        <div class="section-header">
          <div class="section-icon icon-recharge">💰</div>
          <div class="section-title">充值数据</div>
<!--          <button class="refresh-btn" @click="getMessage">刷新</button>-->
        </div>
        <div class="metric-grid">
          <div class="metric-item" v-for="item in rechargeData" :key="item.key">
            <div class="metric-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <!-- 提现相关 -->
      <div class="section-card">
        <div class="section-header">
          <div class="section-icon icon-withdraw">💸</div>
          <div class="section-title">提现数据</div>
<!--          <button class="refresh-btn" @click="getMessage">刷新</button>-->
        </div>
        <div class="metric-grid">
          <div class="metric-item" v-for="item in withdrawData" :key="item.key">
            <div class="metric-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <!-- 用户相关 -->
      <div class="section-card">
        <div class="section-header">
          <div class="section-icon icon-user">👥</div>
          <div class="section-title">用户数据</div>
<!--          <button class="refresh-btn" @click="getMessage">刷新</button>-->
        </div>
        <div class="metric-grid">
          <div class="metric-item" v-for="item in userData" :key="item.key">
            <div class="metric-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <!-- 建仓相关 -->
      <div class="section-card">
        <div class="section-header">
          <div class="section-icon icon-position">⚡️</div>
          <div class="section-title">建仓数据</div>
<!--          <button class="refresh-btn" @click="getMessage">刷新</button>-->
        </div>
        <div class="metric-grid">
          <div class="metric-item" v-for="item in positionData" :key="item.key">
            <div class="metric-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 未来5天平仓预测 -->
    <div class="forecast-section">
      <div class="forecast-header">
        <div class="forecast-title">
          <span style="font-size: 20px;">📈</span>
          未来5天平仓预测
        </div>
<!--        <button class="refresh-btn" @click="getMessage">刷新预测</button>-->
      </div>
      <div class="forecast-list">
        <div class="forecast-card" v-for="day in forecastData" :key="day.date">
          <div class="forecast-date">{{ day.date }}</div>
          <div class="forecast-amount">{{ day.amount }}</div>
        </div>
      </div>
    </div>

    <!-- 其他数据 -->
    <div class="bottom-grid">
      <!-- 收益数据 -->
      <div class="section-card">
        <div class="section-header">
          <div class="section-icon" style="background: linear-gradient(135deg, #4caf50, #388e3c);">📊</div>
          <div class="section-title">收益数据</div>
        </div>
        <div class="metric-grid">
          <div class="metric-item" v-for="item in revenueData" :key="item.key">
            <div class="metric-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <!-- 平仓数据 -->
      <div class="section-card">
        <div class="section-header">
          <div class="section-icon" style="background: linear-gradient(135deg, #f44336, #d32f2f);">📉</div>
          <div class="section-title">平仓数据</div>
        </div>
        <div class="metric-grid">
          <div class="metric-item" v-for="item in closePositionData" :key="item.key">
            <div class="metric-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </div>

      <!-- 业务员数据 -->
      <div class="section-card">
        <div class="section-header">
          <div class="section-icon" style="background: linear-gradient(135deg, #ff5722, #d84315);">👨‍💼</div>
          <div class="section-title">业务数据</div>
        </div>
        <div class="metric-grid">
          <div class="metric-item" v-for="item in businessData" :key="item.key">
            <div class="metric-value" :class="{ pulse: item.isUpdating }">
              {{ item.value }}
            </div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {format} from "date-fns";
import {closeLoading, DO_NET_URL, loading} from "@/config/config";
import {axiosGet} from "@/main";

export default {
name: "DataCount",
  data(){
    return{
      currentTime: '',
      onlineUsers: 1247,
      isRefreshing: false,

      // 平台总余额
      platformBalance: {
        amount: 3847529.68,
        usdt: 15.8,
        isUpdating: false
      },

      // 概览统计
      overviewStats: [
        { key: 'totalUsers', label: '总注册人数', value: '15,847'},
        { key: 'todayLogin', label: '今日登录人数', value: '4,583'},
        { key: 'totalRecharge', label: '总充值金额', value: '¥284万'},
        { key: 'totalWithdraw', label: '总提现金额', value: '¥192万'}
      ],

      // 充值数据
      rechargeData: [
        { key: 'totalRecharge', label: '总充值金额', value: '¥2,847,392', isUpdating: false },
        { key: 'todayRecharge', label: '今日充值金额', value: '¥47,528', isUpdating: false },
        { key: 'todayRechargeCount', label: '今日充值笔数', value: '189笔', isUpdating: false },
        { key: 'unrecharge', label: '注册未充值人数', value: '1,593人', isUpdating: false }
      ],

      // 提现数据
      withdrawData: [
        { key: 'totalWithdraw', label: '总提现金额', value: '¥1,923,847', isUpdating: false },
        { key: 'todayWithdraw', label: '今日提现金额', value: '¥32,194', isUpdating: false },
        { key: 'todayWithdrawCount', label: '今日提现笔数', value: '78笔', isUpdating: false },
        { key: 'businessTransfer', label: '业务员对外转账', value: '¥198,536', isUpdating: false }
      ],

      // 用户数据
      userData: [
        { key: 'totalUsers', label: '总注册人数', value: '15,847', isUpdating: false },
        { key: 'todayRegister', label: '今日注册人数', value: '592', isUpdating: false },
        { key: 'todayLogin', label: '今日登录人数', value: '4,583', isUpdating: false },
        { key: 'unverified', label: '注册未实名人数', value: '2,847', isUpdating: false }
      ],

      // 建仓数据
      positionData: [
        { key: 'totalPosition', label: '建仓过人数', value: '8,293', isUpdating: false },
        { key: 'todayPosition', label: '今日建仓人数', value: '347', isUpdating: false },
        { key: 'todayPositionAmount', label: '今日建仓金额', value: '¥284,750', isUpdating: false },
        { key: 'todayPositionCount', label: '今日建仓笔数', value: '156笔', isUpdating: false }
      ],

      // 收益数据
      revenueData: [
        { key: 'todayRevenue', label: '今日发送收益', value: '¥47,283', isUpdating: false },
        { key: 'yesterdayRevenue', label: '昨日总发送收益', value: '¥52,847', isUpdating: false },
        { key: 'inactiveUsers', label: '超30日不建仓人数', value: '1,248', isUpdating: false },
        // { key: 'placeholder', label: '预留指标', value: '-', isUpdating: false }
      ],

      // 平仓数据
      closePositionData: [
        { key: 'yesterdayClose', label: '昨日平仓金额', value: '¥93,472', isUpdating: false },
        // { key: 'placeholder1', label: '预留数据1', value: '-', isUpdating: false },
        // { key: 'placeholder2', label: '预留数据2', value: '-', isUpdating: false },
        // { key: 'placeholder3', label: '预留数据3', value: '-', isUpdating: false }
      ],

      // 业务员数据
      businessData: [
        { key: 'businessTransfer', label: '今日业务员转账', value: '¥198,536', isUpdating: false },
        // { key: 'placeholder1', label: '预留业务数据1', value: '-', isUpdating: false },
        // { key: 'placeholder2', label: '预留业务数据2', value: '-', isUpdating: false },
        // { key: 'placeholder3', label: '预留业务数据3', value: '-', isUpdating: false }
      ],

      // 未来5天平仓预测
      forecastData: [
        { date: '8月25日 (明天)', amount: '¥128,500' },
        { date: '8月26日', amount: '¥95,200' },
        { date: '8月27日', amount: '¥156,800' },
        { date: '8月28日', amount: '¥203,400' },
        { date: '8月29日', amount: '¥87,300' }
      ]
    }
  },
  mounted() {
    this.getMessage()
  },
  methods: {
   getMessage(){
     loading("加载中")
     let that=this
     this.currentTime = new Date().toLocaleString('zh-CN');
     axiosGet(DO_NET_URL+"dataCount/GetIndexMsgByAdmin",function (res){
       console.log(res)
       closeLoading()
       res=res.data
       that.forecastData=res.forecastData

       that.businessData[0].value=res.businessData.businessTransfer

       that.closePositionData[0].value=res.closePositionData.yesterdayClose

       that.revenueData[0].value=res.revenueData.todayRevenue
       that.revenueData[1].value=res.revenueData.yesterdayRevenue
       that.revenueData[2].value=res.revenueData.inactiveUsers

       that.positionData[0].value=res.positionData.totalPosition
       that.positionData[1].value=res.positionData.todayPosition
       that.positionData[2].value=res.positionData.todayPositionAmount
       that.positionData[3].value=res.positionData.todayPositionCount


       that.userData[0].value=res.userData.totalUsers
       that.userData[1].value=res.userData.todayRegister
       that.userData[2].value=res.userData.todayLogin
       that.userData[3].value=res.userData.unverified


       that.withdrawData[0].value=res.withdrawData.totalWithdraw
       that.withdrawData[1].value=res.withdrawData.todayWithdraw
       that.withdrawData[2].value=res.withdrawData.todayWithdrawCount
       that.withdrawData[3].value=res.withdrawData.businessTransfer


       that.rechargeData[0].value=res.rechargeData.totalRecharge
       that.rechargeData[1].value=res.rechargeData.todayRecharge
       that.rechargeData[2].value=res.rechargeData.todayRechargeCount
       that.rechargeData[3].value=res.rechargeData.unrecharge

       that.overviewStats[0].value=res.overviewStats.totalUsers
       that.overviewStats[1].value=res.overviewStats.todayLogin
       that.overviewStats[2].value=res.overviewStats.totalRecharge
       that.overviewStats[3].value=res.overviewStats.totalWithdraw

       that.platformBalance.amount=res.platformBalance.amount
       that.platformBalance.usdt=res.platformBalance.usdt

     })

   },
    // 更新时间
    // updateTime() {
    //   this.currentTime = new Date().toLocaleString('zh-CN');
    //   setTimeout(this.updateTime, 1000);
    // },

    // 格式化货币
    formatCurrency(amount) {
      return '¥' + amount.toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },

    // 模拟数据更新
    simulateDataUpdate() {
      const sections = ['recharge', 'withdraw', 'user', 'position'];
      const randomSection = sections[Math.floor(Math.random() * sections.length)];
      this.updateSectionData(randomSection);
    },

    // 更新指定部分数据
    updateSectionData(section) {
      const dataMap = {
        'recharge': this.rechargeData,
        'withdraw': this.withdrawData,
        'user': this.userData,
        'position': this.positionData
      };

      const data = dataMap[section];
      if (data) {
        const randomIndex = Math.floor(Math.random() * data.length);
        this.$set(data[randomIndex], 'isUpdating', true);

        setTimeout(() => {
          this.$set(data[randomIndex], 'isUpdating', false);
          // 这里可以更新实际数值
          this.updateActualValue(data[randomIndex]);
        }, 2000);
      }
    },

    // 更新实际数值（示例）
    updateActualValue(item) {
      // 模拟数值变化
      if (item.key.includes('Amount') || item.key.includes('Total')) {
        // 金额类数据的模拟更新
      } else if (item.key.includes('Count') || item.key.includes('Num')) {
        // 数量类数据的模拟更新
      }
    },

    // 刷新概览数据
    refreshOverview() {
      this.isRefreshing = true;
      this.overviewStats.forEach(item => {
        this.$set(item, 'isUpdating', true);
      });

      setTimeout(() => {
        this.isRefreshing = false;
        this.overviewStats.forEach(item => {
          this.$set(item, 'isUpdating', false);
        });
      }, 2000);
    },

    // 刷新指定部分
    refreshSection(section) {
      this.updateSectionData(section);
    },

    // 刷新预测数据
    refreshForecast() {
      // 模拟预测数据更新
      console.log('刷新预测数据');
    },

    // API调用方法（示例）
    async fetchData(endpoint) {
      try {
        // 实际项目中这里会调用真实API
        // const response = await fetch(`/api/${endpoint}`);
        // return await response.json();

        // 模拟API调用
        return new Promise(resolve => {
          setTimeout(() => {
            resolve({
              success: true,
              data: {}
            });
          }, 500);
        });
      } catch (error) {
        console.error('API调用失败:', error);
        return {success: false, error};
      }
    },

    // 导出数据方法
    exportData() {
      const allData = {
        platformBalance: this.platformBalance,
        rechargeData: this.rechargeData,
        withdrawData: this.withdrawData,
        userData: this.userData,
        positionData: this.positionData,
        forecastData: this.forecastData,
        timestamp: new Date().toISOString()
      };

      console.log('导出数据:', allData);
      // 这里可以实现实际的导出功能
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, 'PingFang SC', 'Hiragino Sans GB', sans-serif;
  background: linear-gradient(135deg, #4285f4 0%, #34a853 30%, #1976d2 100%);
  min-height: 100vh;
  color: #333;
  overflow-x: hidden;
}

.dashboard {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
  background-image: linear-gradient(to bottom right,#4782f8,#2e9c5f);
}

.header {
  text-align: center;
  margin-bottom: 25px;
  color: white;
}

.header h1 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 8px;
  text-shadow: 0 2px 10px rgba(0,0,0,0.2);
}

.header-info {
  display: flex;
  justify-content: center;
  gap: 30px;
  font-size: 0.85rem;
  opacity: 0.9;
}

.top-section {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 20px;
  margin-bottom: 25px;
}

.balance-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 25px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  text-align: center;
  position: relative;
  overflow: hidden;
}

.balance-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #4285f4, #34a853, #fbbc04);
}

.balance-title {
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 15px;
  font-weight: 500;
}

.balance-amount {
  font-size: 2.5rem;
  font-weight: 700;
  color: #1976d2;
  margin-bottom: 10px;
}

.balance-unit {
  font-size: 1.2rem;
  color: #666;
}

.balance-change {
  margin-top: 10px;
  font-size: 2.25rem;
  color: #34a853;
  font-weight: 500;
}

.overview-stats {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 25px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.overview-title {
  font-size: 1.1rem;
  color: #333;
  margin-bottom: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

.overview-item {
  text-align: center;
  padding: 15px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(66, 133, 244, 0.1), rgba(52, 168, 83, 0.05));
  transition: all 0.3s ease;
}

.overview-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.overview-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 5px;
}

.overview-label {
  font-size: 1.2rem;
  color: #666;
}

.main-content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 25px;
}

.section-card {
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 25px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.section-card:hover {
  transform: translateY(-3px);
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
}
.section-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: white;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.icon-recharge { background: linear-gradient(135deg, #4285f4, #1976d2); }
.icon-withdraw { background: linear-gradient(135deg, #ff9800, #f57c00); }
.icon-user { background: linear-gradient(135deg, #9c27b0, #7b1fa2); }
.icon-position { background: linear-gradient(135deg, #00bcd4, #0097a7); }

.section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.metric-item {
  background: linear-gradient(135deg, rgba(66, 133, 244, 0.05), rgba(52, 168, 83, 0.02));
  border: 1px solid rgba(66, 133, 244, 0.1);
  border-radius: 12px;
  padding: 15px;
  transition: all 0.3s ease;
  cursor: pointer;
}

.metric-item:hover {
  background: linear-gradient(135deg, rgba(66, 133, 244, 0.08), rgba(52, 168, 83, 0.04));
  border-color: rgba(66, 133, 244, 0.2);
  transform: translateY(-2px);
}

.metric-value {
  font-size: 1.8rem;
  font-weight: 700;
  color: #333;
  margin-bottom: 5px;
}

.metric-label {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.3;
}

.forecast-section {
  grid-column: 1 / -1;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 25px;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  margin-bottom: 25px;
}

.forecast-header {
  display: flex;
  align-items: center;
  justify-content: between;
  margin-bottom: 20px;
}

.forecast-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  color: #333;
}

.forecast-list {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 15px;
}

.forecast-card {
  background: linear-gradient(135deg, #4285f4, #34a853);
  border-radius: 12px;
  padding: 18px;
  color: white;
  text-align: center;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease;
}

.forecast-card:hover {
  transform: translateY(-3px);
}

.forecast-card::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.forecast-date {
  font-size: 1.2rem;
  margin-bottom: 8px;
  opacity: 0.9;
}

.forecast-amount {
  font-size: 1.2rem;
  font-weight: 700;
  position: relative;
  z-index: 2;
}

.forecast-card:nth-child(2) { background: linear-gradient(135deg, #ff9800, #f57c00); }
.forecast-card:nth-child(3) { background: linear-gradient(135deg, #9c27b0, #7b1fa2); }
.forecast-card:nth-child(4) { background: linear-gradient(135deg, #00bcd4, #0097a7); }
.forecast-card:nth-child(5) { background: linear-gradient(135deg, #4caf50, #388e3c); }

.bottom-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.pulse {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.02);
    opacity: 0.9;
  }
}

.loading {
  opacity: 0.7;
  pointer-events: none;
}

.refresh-btn {
  background: linear-gradient(135deg, #4285f4, #34a853);
  border: none;
  border-radius: 20px;
  padding: 8px 16px;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-left: auto;
}

.refresh-btn:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 15px rgba(66, 133, 244, 0.3);
}

@media (max-width: 1024px) {
  .top-section {
    grid-template-columns: 1fr;
  }

  .main-content {
    grid-template-columns: 1fr;
  }

  .overview-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .forecast-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .dashboard {
    padding: 15px;
  }

  .header h1 {
    font-size: 1.5rem;
  }

  .header-info {
    flex-direction: column;
    gap: 5px;
  }

  .overview-grid {
    grid-template-columns: 1fr;
  }

  .forecast-list {
    grid-template-columns: 1fr;
  }

  .bottom-grid {
    grid-template-columns: 1fr;
  }
}

</style>